"use client";
import React, { useState, useEffect } from "react";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Getorder.css";
import "./modal.css";

export default function ManagerOrders() {
    const { t } = useTranslation();

    const TABS = [
        { label: t('managerOrders.tabs.new'),       value: "PENDING"   },
        { label: t('managerOrders.tabs.confirmed'), value: "ACCEPTED"  },
        { label: t('managerOrders.tabs.ready'),     value: "CONFIRMED" },
        { label: t('managerOrders.tabs.shipped'),   value: "SHIPPED"   },
        { label: t('managerOrders.tabs.rejected'),  value: "REJECTED"  },
    ];

    const [orders,setOrders] = useState([]);
    const [search,setSearch] = useState("");
    const [sel,setSel]       = useState(null);
    const [show,setShow]     = useState(false);

    const [tab,setTab]   = useState("PENDING");
    const [page,setPage] = useState(0);
    const size = 10;
    const [total,setTotal]=useState(0);

    const base = process.env.REACT_APP_API_BASE_URL;
    const fileApi = `${base}/public/images/`;

    const load = async(t,p)=>{
        try{
            const token=sessionStorage.getItem("accessToken");
            const { data } = await axios.get(`${base}/manager/orders/by-track-status`,{
                params:{trackStatus:t,page:p,size},
                headers:{Authorization:`Bearer ${token}`},
            });
            let list=data.content||[];
            if(t==="PENDING") list=list.filter(o=>o.payStatus==="CONFIRMED");
            setOrders(list); setTotal(data.totalPages||0);
        }catch{Notify.failure(t('managerOrders.errors.loadFailed'));}
    };
    useEffect(()=>{ load(tab,page); },[tab,page]);

    const filt=orders.filter(o=>{
        let txt=""; Object.entries(o).forEach(([k,v])=>{ if(k!=="items") txt+=String(v).toLowerCase()+" "; });
        o.items?.forEach(i=>{ txt+=i.name.toLowerCase()+" "+i.quantity+" "; });
        return txt.includes(search.toLowerCase());
    });

    const downloadPdf = async (fileName)=>{
        try{
            const res = await fetch(`${fileApi}${encodeURIComponent(fileName)}`);
            if(!res.ok) throw new Error("Fetch error");
            const blob = await res.blob();
            const url  = URL.createObjectURL(blob);
            const a    = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }catch{Notify.failure(t('managerOrders.errors.downloadFailed'));}
    };

    const open=o=>{setSel(o);setShow(true);} , close=()=>setShow(false);
    const modal=()=>show&&sel&&(
        <div className="modal-overlay" onClick={close}>
            <div className="modal-content" onClick={e=>e.stopPropagation()}>
                <div className="modal-header">
                    <h5 className="modal-title">{t('managerOrders.modal.title')} #{sel.orderId}</h5>
                    <button className="close-button" onClick={close}>&times;</button>
                </div>
                <div className="modal-body">
                    <p><b>{t('managerOrders.modal.date')}:</b> {new Date(sel.orderDate).toLocaleString()}</p>
                    <p><b>{t('managerOrders.modal.trackStatus')}:</b> {sel.trackStatus}</p>
                    <p><b>{t('managerOrders.modal.payStatus')}:</b> {sel.payStatus}</p>
                    <p><b>{t('managerOrders.modal.amount')}:</b> {sel.totalPrice}</p>
                    <p><b>{t('managerOrders.modal.name')}:</b> {sel.firstname ?? "-"} {sel.lastname ?? "-"}</p>
                    <p><b>{t('managerOrders.modal.phone')}:</b> {sel.phoneNumber ?? "-"}</p>
                    <h6>{t('managerOrders.modal.items')}:</h6>
                    {sel.items?.map((i,idx)=><div key={idx}>{i.name} × {i.quantity}</div>)}

                    {sel.fileName && (
                        <div className="mt-3 d-flex gap-2 flex-wrap">
                            <a
                                href={`${fileApi}${encodeURIComponent(sel.fileName)}`}
                                target="_blank" rel="noopener noreferrer"
                                className="btn btn-outline-primary"
                            >
                                {t('managerOrders.modal.openReceipt')}
                            </a>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={()=>downloadPdf(sel.fileName)}
                            >
                                {t('managerOrders.modal.downloadPdf')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    const auth = () => ({ Authorization:`Bearer ${sessionStorage.getItem("accessToken")}` });

    const changeStatuses = async (id,newTrack,newPay)=>{
        try{
            if(newTrack) await axios.get(`${base}/manager/update/track-status/${id}`,{params:{trackStatus:newTrack},headers:auth()});
            Notify.success(t('managerOrders.success.statusUpdated'));
            setTab(newTrack||tab); setPage(0);
        }catch{Notify.failure(t('managerOrders.errors.statusUpdateFailed'));}
    };

    const nextTrack=s=>({PENDING:"ACCEPTED",ACCEPTED:"CONFIRMED",CONFIRMED:"SHIPPED"})[s]||null;

    return (
        <div className="mt-4">
            <div className="mb-3">
                {TABS.map(t=>(
                    <button key={t.value}
                            className={`btn me-2 ${tab===t.value?"bg-danger active text-white":"btn-outline-primary"}`}
                            onClick={()=>{setTab(t.value);setPage(0);}}
                    >{t.label}</button>
                ))}
            </div>

            {/* поиск */}
            <div className="row mb-3"><div className="col">
                <input className="form-control" placeholder={t('managerOrders.searchPlaceholder')}
                       value={search} onChange={e=>setSearch(e.target.value)}/>
            </div></div>

            {filt.length?(
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead className="thead-light">
                        <tr>
                            <th>{t('managerOrders.table.id')}</th>
                            <th>{t('managerOrders.table.date')}</th>
                            <th>{t('managerOrders.table.trackStatus')}</th>
                            <th>{t('managerOrders.table.payStatus')}</th>
                            <th>{t('managerOrders.table.amount')}</th>
                            <th>{t('managerOrders.table.name')}</th>
                            <th>{t('managerOrders.table.items')}</th>
                            <th>{t('managerOrders.table.actions')}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {filt.map(o=>(
                            <tr key={o.orderId}>
                                <td>{o.orderId}</td>
                                <td>{new Date(o.orderDate).toLocaleString()}</td>
                                <td>{o.trackStatus}</td>
                                <td>{o.payStatus}</td>
                                <td>{o.totalPrice}</td>
                                <td>{o.firstname}</td>
                                <td>{o.items?.map((i,idx)=><div key={idx}>{i.name} × {i.quantity}</div>)}</td>
                                <td>
                                    <button className="btn btn-info btn-sm me-2" onClick={()=>open(o)}>
                                        {t('actions.details')}
                                    </button>

                                    {nextTrack(o.trackStatus)&&(
                                        <button className="btn btn-success btn-sm me-2"
                                                onClick={()=>{
                                                    if(o.trackStatus==="PENDING")
                                                        changeStatuses(o.orderId,"ACCEPTED","APPROVED");
                                                    else
                                                        changeStatuses(o.orderId,nextTrack(o.trackStatus),null);
                                                }}>
                                            {o.trackStatus==="CONFIRMED"?t('managerOrders.buttons.ship'):t('managerOrders.buttons.accept')}
                                        </button>
                                    )}

                                    {tab==="PENDING"&&(
                                        <button className="btn btn-danger btn-sm"
                                                onClick={()=>changeStatuses(o.orderId,"REJECTED","FAILED")}>
                                            {t('managerOrders.buttons.reject')}
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ):<p className="text-center">{t('managerOrders.noOrders')}</p>}

            <div className="d-flex justify-content-center align-items-center my-3">
                <button className="btn btn-outline-primary me-2" disabled={page<=0}
                        onClick={()=>setPage(p=>Math.max(p-1,0))}>← {t('managerOrders.pagination.prev')}</button>
                <span>{t('managerOrders.pagination.page')} {page+1} {t('managerOrders.pagination.of')} {total}</span>
                <button className="btn btn-outline-primary ms-2" disabled={page>=total-1}
                        onClick={()=>setPage(p=>Math.min(p+1,total-1))}>{t('managerOrders.pagination.next')} →</button>
            </div>

            {modal()}
        </div>
    );
}